// extracted by mini-css-extract-plugin
export default {"Label":"styledLabel_Label__S4ipW","Help":"styledLabel_Help__7Dth6"};